<template>
  <v-layout class="justify-center">
    <v-dialog v-model="dialog" v-closable="{ exclude: [], handler: 'cancel' }" @keydown.esc="$emit('closeDialog')" persistent max-width="520">
      <template v-slot:activator="{ on }">
        <div class="cursor-type flex justify-center" v-on="on">
          <slot></slot>
        </div>
      </template>
      <v-card>
        <v-card-title class="headline font-weight-black text-color-title">{{i18n(headerText)}}</v-card-title>
        <v-card-text>
          <h3>{{i18n('Conta de origem')}}</h3>
          <v-text-field readonly :value="source_bank_account_name"></v-text-field>
        </v-card-text>
        <v-card-text>
          <h3>{{i18n('Parceiro')}}</h3>
          <CompanySelect
            ref="companySelect"
            :model="selected_company_id"
            :initial_search="partnerSearchValue"
            label="Pesquisar"
            @onIdSelected="this.setCompanyId"
          />
        </v-card-text>
        <v-card-text>
          <h3>{{i18n('Conta de destino')}}</h3>
          <v-select
            label="Conta Parceiro"
            :disabled="!selected_company_id"
            :items="partnerBankAccounts"
            v-model="partner_bank_account"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-layout>
            <v-flex class="justify-space-around">
              <v-btn flat class="mr-1 font-weight-black text-color" @click="cancel">{{i18n('Cancelar')}}</v-btn>
              <v-btn flat class="pa-2 font-weight-black adjust-btn-width secondary-bg-color cancel-btn"
                dark :disabled="!partner_bank_account" @click="saveAssociation">{{i18n(saveButtonText)}}</v-btn>
              <v-btn depressed class="mr-1" color="error" v-if="!newAssociation">
                <DeleteModal title="Excluir associação" @onConfirm="deleteAssociation">
                  {{i18n('Excluir')}}
                </DeleteModal>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import utils from "./shared/Utils";
  import DeleteModal from "./DeleteModal"
  import CompanySelect from "./components/filters/CompanySelect"
  export default {
    name: 'AutoScheduleModal',
    components: { DeleteModal, CompanySelect },
    props: {
      sourceBankAccount: {
        type: Object,
        default: {}
      },
      accounts: {
        type: Array,
        default: []
      },
      dialog: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        opening: false,
        newAssociation: true,
        selected_company_id: null,
        partnerBankAccounts: [],
        partnerSearchValue: null,
        partner_bank_account: null,
        source_bank_account_name: null,
      }
    },
    methods: {
      i18n(str) {
        return this.$root.l(str)
      },
      cancel(_str) {
        if (!this.isMobile && this.dialog === true && !this.opening) {
          this.$emit('closeDialog')
        }
      },
      setCompanyId(id) {
        if (id) {
          this.selected_company_id = id
          this.loadBankAccountsFromCompany(id)
        }
      },
      loadBankAccountsFromCompany(id) {
        let successCallback = (response) => {
          if (response.body.data) {
            this.$set(this, 'partnerBankAccounts', response.body.data
              .map((rec) => { return {value: rec.id, text: utils.longAccountName(rec), currency: rec.currency} })
            )
            this.newAssociation || this.loadAutoScheduleAssociation()
          }
        }
        let errorCallback = (response) => {
          console.log(response);
        }

        this.$http.get(
          this.$root.urls.admin__bank_accounts.split('ID').join(id),
          this.requestHeader
        ).then(successCallback, errorCallback)
      },
      loadAutoScheduleAssociation() {
        this.$http.get(this.accountUrl, this.requestHeader).then((response) => {
          const { company, to_bank_account_id } = response.body.data
          this.partnerSearchValue = company.social_name
          this.partner_bank_account = to_bank_account_id
        })
      },
      saveAssociation() {
        let successCallback = () => {
          this.$emit('closeDialog', true)
        }
        let errorCallback = (response) => {
          console.log('errorCallback', response)
        }

        let payload = {
          "auto_schedule_bank_account": {
            "bank_account_id": this.sourceBankAccount.id,
            "company_id": this.selected_company_id,
            "to_bank_account_id": this.partner_bank_account
          }
        }

        if (this.newAssociation) {
          this.$http.post(
            this.$root.urls.admin__auto_schedule_bank_accounts,
            payload,
            this.requestHeader
          ).then(successCallback, errorCallback)
        } else {
          this.$http.put(this.accountUrl, payload, this.requestHeader)
            .then(successCallback, errorCallback)
        }
      },
      async deleteAssociation() {
        await this.$http.delete(this.accountUrl, this.requestHeader)
        this.$emit('closeDialog', true)
      }
    },
    computed: {
      headerText() {
        return this.newAssociation
          ? 'Associar conta exclusiva'
          : 'Alterar/excluir conta exclusiva'
      },
      saveButtonText() {
        return this.newAssociation
          ? 'Associar'
          : 'Alterar'
      },
      accountUrl() {
        return `${this.$root.urls.admin__auto_schedule_bank_accounts}/${this.sourceBankAccount.id}`
      },
      requestHeader() {
        let token = this.$cookies.get('api_token')
        return { headers: { Authorization: `Bearer ${token}` }}
      }
    },
    watch: {
      dialog(is_open) {
        if (is_open) {
          this.opening = true
          setTimeout(function() { 
            this.$nextTick(() => {
              this.opening = false
              if (this.$refs.companySelect && this.$refs.companySelect.reset) {
                this.$refs.companySelect.reset()
              }
            })
          }.bind(this), 500)
          
          this.source_bank_account_name = utils.longAccountName(this.sourceBankAccount)
          
          if (this.sourceBankAccount.exclusive_for) {
            this.newAssociation = false
            this.setCompanyId(this.sourceBankAccount.exclusive_for.id)
          } else {
            this.newAssociation = true
            this.selected_company_id = null
            this.partnerSearchValue = null
            this.partner_bank_account = null
            this.partnerBankAccounts = []
          }
        }
      },
    },
  }
</script>

<style scoped>
.secondary-bg-color {
  background-color: var(--secondary-button-background-color) !important;
}
.color-text-literals {
  color: rgba(46, 49, 49, 1) !important;
}
.text-color {
  color: var(--background-color) !important;
}
.text-color-title {
  color: #44517B  !important;
}
.cursor-type {
  cursor: pointer;
}
.flex {
  display: flex;
}
.flex-justify-between {
  display: flex;
  justify-items: between;
}
</style>



// WEBPACK FOOTER //
// src/AutoScheduleModal.vue